import { upperFirst } from 'Utils';
// eslint-disable-next-line import/no-cycle
import { getServerErrorByCode, IRequestErrorServerResponse, RequestError } from 'Api';

export class BaseFormModelErrorHandler {
  getErrorMessageByServerResponse(serverResponse?: IRequestErrorServerResponse | string) {
    if (!serverResponse) return '';
    if (typeof serverResponse === 'string') return upperFirst(serverResponse);
    const serverErrorByCode = getServerErrorByCode(serverResponse?.code as string);
    if (serverErrorByCode) {
      return serverErrorByCode;
    }
    if (serverResponse.__error__) {
      const { __error__ } = serverResponse;
      if (Array.isArray(__error__)) {
        return __error__.map(errorString => upperFirst(errorString)).join(', ');
      }
      if (typeof __error__ !== 'string' && __error__?.statusDesc) {
        return __error__.statusDesc;
      }
      return JSON.stringify(__error__).replace(/"/g, '');
    }
    return upperFirst(serverResponse.error || serverResponse.result || serverResponse.message || '');
  }

  getNormalizedError(error: RequestError) {
    const errorMessage = this.getErrorMessageByServerResponse(error.data);
    return new RequestError(errorMessage, error.response, error.data);
  }
}
